__turbopack_context__.v({
  "active": "timeline-divider-module__d3Z5_a__active",
  "detail": "timeline-divider-module__d3Z5_a__detail",
  "divider": "timeline-divider-module__d3Z5_a__divider",
  "label": "timeline-divider-module__d3Z5_a__label",
  "rule": "timeline-divider-module__d3Z5_a__rule",
});
